/*
 * DRIVLY-UI React Components
 * @license MIT
 */
const o=o=>Boolean(o&&o.getVelocity);export{o as isMotionValue};
//# sourceMappingURL=is-motion-value.js.map
